"use client";

import React, { useState } from "react";
import Button from "../../../ui/Button";
import { CompanyName } from "../../design1/components/TrustedPartner";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { formatNumber } from "../../design1/components/TrustedPartner";
const Guiding = ({ config }: { config: Config }) => {
  const info = config;
  const stats = info?.companyStat;
  return (
    <section className="py-20 xs:py-10">
      <div className="wrapper justify-between lg:flex-col lg:gap-14 gap-10 flex">
        <div className="first flex flex-col gap-6">
          <h2 className="text-themeColor max-w-[400px] font-semibold">
            Guiding You Through Every Property Step
          </h2>
          <p className="mb-6 h6 max-w-[680px] text-secondary-main">
            {<CompanyName />}! We are excited to offer premium real estate
            services throughout Nigeria. Our platform features exclusive
            listings for over{" "}
            {info?.companyStat?.total_properties.toLocaleString()} properties,
            backed by {stats?.total_branch} branches and a skilled team of{" "}
            {stats?.total_staff} real estate professionals. With over{" "}
            {stats?.years_in_industry} {""}
            of industry experience, we specialize in property sales, rentals,
            short lets, and other essential real estate services across the
            nation. Let us be your trusted partner in navigating every step of
            your real estate journey.
          </p>
          <Button href="/about" className="!w-max !py-3 !px-8 text-[14px]">
            Read More
          </Button>
        </div>
        <CardHolder />
      </div>
    </section>
  );
};
export default Guiding;

const Card: React.FC<{
  icon: React.FC<{ color: string }>;
  header: string;
  text: string;
}> = ({ icon, header, text }) => {
  const Icon = icon;
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      className={`flex transition-all lg:max-w-[350px] xsm:max-w-[80%] xsm:mx-auto xsm:!grid-cols-1 md:w-full duration-500 xs:p-4 p-8  pb-10 rounded-2xl flex-col items-center ${
        hovered
          ? "bg-themeColor scale-125 xs:scale-[1.1] text-white"
          : "bg-[rgba(var(--primary-color-rgb),0.1)] scale-100 text-themeColor "
      }`}
    >
      <div
        className={`size-[4.2rem] mb-4 transition-all duration-500 grid place-items-center ${
          !hovered ? "bg-themeColor" : "bg-white"
        } rounded-full`}
      >
        <Icon color={!hovered ? "white" : "var(--primary-color)"} />
      </div>

      <h3 className="font-semibold">{header}</h3>
      <h4 className="h6 whitespace-nowrap">{text}</h4>
    </div>
  );
};

import { House1Icon, House2Icon, PersonIcon, TimeIcon } from "../index";
import { Config } from "src/types";

const CardHolder = () => {
  const { data: info } = useFetchCompanyInfo();
  const stats = info?.companyStat;
  const GuidingData = [
    {
      header: formatNumber(stats?.total_properties || 0),
      text: "Direct Properties",
      icon: House1Icon,
    },
    {
      header: formatNumber(stats?.total_branch || 0),
      text: "Total Branches",
      icon: House2Icon,
    },
    {
      header: formatNumber(stats?.total_staff || 0),
      text: "Total Professional Staffs",
      icon: PersonIcon,
    },
    {
      header: formatNumber(
        Number(stats?.years_in_industry.match(/\d+/)?.[0]) || 0
      ),
      text: "Years Of Experience",
      icon: TimeIcon,
    },
  ];

  return (
    <div className="grid gap-14 lg:!w-full   xsm:grid-cols-1 lg:mx-auto xs:gap-8 xxs:!gap-2 grid-cols-2">
      {GuidingData.map((item, index) => {
        return <Card key={index} {...item} />;
      })}
    </div>
  );
};
